import italianInItaly from '../locale/locale.js';

/**
 * Formats a distance value in meters into a human-readable string using Italian locale conventions.
 *
 * - For values less than 1000 meters, the result is formatted in meters (e.g., "850 m").
 * - For values 1000 meters or greater, the result is formatted in kilometers with up to one decimal (e.g., "1,2 km").
 * - Falls back to a simple "X km" string if formatting fails.
 *
 * @param value - The distance in meters to format.
 * @returns The formatted distance string.
 *
 * @example
 * ```ts
 * formatDistance(850); // "850 m"
 * formatDistance(1200); // "1,2 km"
 * formatDistance(1000000); // "1.000 km"
 * ```
 */
const formatDistance = (value) => {
    try {
        if (Math.abs(value) < 1000) {
            return Intl.NumberFormat(italianInItaly, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 1,
                style: 'unit',
                unit: 'meter',
                unitDisplay: 'short',
            }).format(value);
        }
        else {
            return Intl.NumberFormat(italianInItaly, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 1,
                style: 'unit',
                unit: 'kilometer',
                unitDisplay: 'short',
                useGrouping: true,
            }).format(value / 1000);
        }
    }
    catch {
        const simpleNumber = Intl.NumberFormat(italianInItaly, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
        }).format(value / 1000);
        return `${simpleNumber} km`;
    }
};

export { formatDistance as default };
//# sourceMappingURL=formatDistance.js.map
